<template>
    <span>
        <el-button
        type="text"
        v-if="row.shbj==='1'"
        icon="el-icon-setting"
        @click="dialogShow('xmzl')">
            设置项目助理
        </el-button>

        <el-button
        type="text"
        v-if="row.shbj==='1'&&(row.sjly!=='1'||!row.spxmbh)"
        icon="el-icon-document-add"
        @click="dialogShow('xmdm')">
            补充统一项目代码
        </el-button>

        <el-button 
        type="success" 
        icon="el-icon-plus" 
        v-if="row.val==='add'"
        @click="addHandler">
            添加项目
        </el-button>
        

        <my-dialog
        v-model="dialogVisible"
        :title="dialogTitle">
            <form-elec-agree
            v-if="dialogVisible"
            :row="row"
            :type="type"
            @reloadpage="$emit('reload')"
            @cancle="dialogClose">
            </form-elec-agree>
        </my-dialog>
    </span>
</template>

<script>
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FormElecAgree from './form'

export default {
    mixins: [DIALOG_LIST_PAGE_MIXIN],
    components: {FormElecAgree},
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
       
    },
    data () {
        return {
            dialogVisible:false,
            type:'',
            dialogTitle:''
        }
    },
    watch: {
        dialogClose:function(){
            alert(1)
        }
    },
    methods: {
        dialogShow(val){
            this.dialogTitle = val==='xmzl' ? '设置项目助理' : '补充统一项目代码'
            this.type = val
            this.dialogVisible = true
        },
        // 添加项目弹窗
        addHandler(){
            this.dialogTitle = '添加项目';
            this.type = 'add';
            this.dialogVisible = true;
        },


    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
